import Analytics from 'analytics';
import googleAnalyticsPlugin from '@analytics/google-analytics';

// Initialize analytics and plugins
// Documentation: https://getanalytics.io
const analytics = Analytics({
  debug: process.env.NODE_ENV !== 'production',
  app: 'showrunner',
  plugins: [
    googleAnalyticsPlugin({
      measurementIds: [process.env.REACT_APP_GA_MEASUREMENT_ID],
    }),
  ],
});

// Initial + subsequent pageviews are sent from <AnalyticsPageViews /> (useLocation) under <Router>.

export default analytics;
